import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import imageSrc from '../../assets/images/slide/start-life-book-tablet.png';
import styles from './StartSlideV12.css';

function StartSlideV12({ id, onContinue }) {
    const handleChange = label => () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label });
        onContinue();
    };

    return (
        <div className={styles.form} key={id}>
            <ul className={styles.badges}>
                <li className={styles.badge}>
                    <span className={styles.badgeIcon}>
                        <Icon name='micFilled' />
                    </span>
                    <span className={styles.badgeText}>Speak or type</span>
                </li>
                <li className={styles.badge}>
                    <span className={styles.badgeIcon}>
                        <Icon name='lockFilled' />
                    </span>
                    <span className={styles.badgeText}>Private by default</span>
                </li>
            </ul>
            <img src={imageSrc} alt='' className={styles.image} />
            <h1 className={styles.heading}>Could the life you’ve lived fill a book?</h1>
            <p className={styles.subheading}>Pass the quiz to personalize your subscription</p>
            <div className={styles.answers}>
                <button type='button' onClick={handleChange('Yes, I think so')} className={styles.answerButton}>
                    <span className={styles.answerText}>Yes, I think so</span>
                    <span className={styles.answerIcon}>
                        <Icon name='chevronRight' />
                    </span>
                </button>
                <button type='button' onClick={handleChange('I’m not sure')} className={styles.answerButton}>
                    <span className={styles.answerText}>I’m not sure</span>
                    <span className={styles.answerIcon}>
                        <Icon name='chevronRight' />
                    </span>
                </button>
            </div>
        </div>
    );
}

StartSlideV12.propTypes = {
    id: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired
};

export {
    StartSlideV12
};
